import { render, staticRenderFns } from "./VideoEditor.vue?vue&type=template&id=0f61dfdc&scoped=true&"
import script from "./VideoEditor.vue?vue&type=script&lang=ts&"
export * from "./VideoEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f61dfdc",
  null
  
)

export default component.exports